Ext.define('SA.TimeSeriesEditController', {
    constructor({model, activeState}) {
        this.model = model;
        this.activeState = activeState;

        this.modelLocations = new SA.EditModelLocations(model);
        this.modelAttributes = new SA.EditModelAttributes(model);

        this.validator = SA.EditValidator.forModel(this.model);
        this.validator.requireLocation();
        this.validator.requireAttribute();

        this.locationsPanel = SA.EditPanelBuilder.forLocations().withSelectionButtons().withCheckboxes().build();
        this.attributesPanel = SA.EditPanelBuilder.forAttributes().withRadios().build();

        this.view = Ext.widget({xtype: 'edit-view', panels: [this.locationsPanel.getView(), this.attributesPanel.getView()]});

        this.initEvents();
    },

    initEvents() {
        this.modelObserver = SA.EditModelObserver.create(this.model, this.refresh, this);
        this.modelObserver.observeName();
        this.modelObserver.observeLocations();
        this.modelObserver.observeAttributes();

        this.activeState.onActive(this.refresh, this);
        this.activeState.onChange(active => this.modelObserver.setEnabled(active));

        this.sidebarObserver = new SA.SidebarObserver(this.activeState);
        this.sidebarObserver.onUseLocation(this.onSidebarUseLocation, this);
        this.sidebarObserver.onUseAttribute(this.onSidebarUseAttribute, this);

        this.view.onDoneClick(() => SA.AppController.showProjectView(this.model));

        this.locationsPanel.onSelectAllClick(ids => this.modelLocations.select(ids));
        this.locationsPanel.onClearClick(() => this.modelLocations.clear());
        this.locationsPanel.onItemChange((checkbox, checked) => this.modelLocations.toggle(checkbox.getDataId(), checked));

        this.attributesPanel.onItemChange(radio => this.modelAttributes.select(radio.getDataId()));
    },

    getView() {
        return this.view;
    },

    onSidebarUseAttribute(id) {
        this.view.scrollToEl(() => this.attributesPanel.getEnabledItemEl(id));
    },

    onSidebarUseLocation(id) {
        this.view.scrollToEl(() => this.locationsPanel.getEnabledItemEl(id));
    },

    refresh() {
        this.view.setViewName(this.model.getName());
        this.view.setWarningMessage(this.validator.getFirstMessage());

        this.locationsPanel
            .setEnabledIds(this.modelLocations.getSupported())
            .setDisabledIds(this.modelLocations.getUnsupported())
            .eachItem(item => item.refreshLabel())
            .eachEnabledItem(item => item.setCheckedSuppressed(this.modelLocations.isSelected(item.getDataId())));

        this.attributesPanel
            .setEnabledIds(this.modelAttributes.getSupported())
            .setDisabledIds(this.modelAttributes.getUnsupported())
            .eachEnabledItem(item => item.setCheckedSuppressed(this.modelAttributes.isSelected(item.getDataId())));
    }
});